module.exports = __webpack_public_path__ + "img/more-menu.9af2c6cb.svg";